import { Object3D } from "three";

/**
 * A generator function to traverse an Object3D hierarchy. Unlike the
 * Object3D.traverse method, this can stop traversal after a success by simply
 * breaking out of the loop that is consuming the generator.
 *
 * It should be safe to remove the current element from its parent object
 * during traversal because the function iterates backwards.
 */
export function* traverse(obj: Object3D) {
    yield obj;
    if(obj && obj.children.length > 0) {
        for(let i=obj.children.length - 1; i >= 0; i--) {
            yield* traverse(obj.children[i]);
        }
    }
}
export default traverse;
